export default function () {
  return {
    current: {
      id: '',
      name: '',
      permissions: [],
      users: []
    },
    update: {
      id: '',
      name: ''
    },
    list: [],
    actions: []
  }
}
